import { render, staticRenderFns } from "./StatsTeamFilter.vue?vue&type=template&id=74a42f33&scoped=true&"
import script from "./StatsTeamFilter.vue?vue&type=script&lang=js&"
export * from "./StatsTeamFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a42f33",
  null
  
)

export default component.exports